<script>
import api from './api'
export default {
  loadSettings () {
    return api.getData('insights/loadsettings')
  },
  loadSharedSettings () {
    return api.getData('insights/loadsharedsettings')
  },
  saveSettings (formData) {
    return api.post('insights/savesettings', formData)
  },
  loadData (params) {
    return api.get('insights/data', params)
  },
  downloadData (params) {
    return api.download('insights/download', params)
  },
  loadChannels (ids) {
    return api.getData('insights/channels', {ids: ids})
  },
  listTrackedChannels (params) {
    return api.get('insights/trackedchannels')
  },
  refresh () {
    return api.get('insights/refresh')
  }
}
</script>



// WEBPACK FOOTER //
// insights.vue?5552e8d7